import React from "react";
import { motion } from "framer-motion";
import MerchantLayout from "../components/MerchantLayout";
import { LiveBoard } from "../components/LiveBoard";
import { useMerchantData } from "../hooks/useMerchantData";
import { StatsRow, NeedProfileForm, IssueTab, SubscribeTab, HistoryTab, KycTab } from "../components/merchant/MerchantTabs";

export default function MerchantDashboard() {
  const d = useMerchantData();

  if (d.needProfile) {
    return (
      <MerchantLayout active="issue">
        <NeedProfileForm biz={d.biz} setBiz={d.setBiz} createProfile={d.createProfile} busy={d.busy} />
      </MerchantLayout>
    );
  }

  const m = d.me?.merchant;
  return (
    <MerchantLayout active={d.tab} onNav={d.setTab}>
      <StatsRow m={m} plan={d.me?.plan} />
      {d.tab === "live" && <LiveBoard />}
      {d.tab === "issue" && <IssueTab m={m} form={d.form} setForm={d.setForm} issue={d.issue} busy={d.busy} />}
      {d.tab === "subscribe" && (
        <SubscribeTab refApplied={d.refApplied} refCode={d.refCode} setRefCode={d.setRefCode}
          applyReferral={d.applyReferral} busy={d.busy} plans={d.plans}
          subscribe={d.subscribe} devActivate={d.devActivate} appCfg={d.appCfg} />
      )}
      {d.tab === "history" && <HistoryTab tokens={d.tokens} />}
      {d.tab === "kyc" && <KycTab kyc={d.kyc} uploadKyc={d.uploadKyc} />}
    </MerchantLayout>
  );
}
